import { useState } from 'react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import type { AdminAlert } from '../../../domain/Admin';
import { useAdminList } from './useAdminList';

// Alertas configuradas (con buscador y "solo disparadas") e historial de
// disparos (con buscador), cada uno de a una página.
export function useAdminAlerts() {
  const { admin } = useRepositories();
  const [tab, setTab] = useState<'configured' | 'events'>('configured');
  const [onlyTriggered, setOnlyTriggered] = useState(false);
  const alerts = useAdminList(
    (params) => admin.fetchAlerts({ ...params, triggered: onlyTriggered }).then((r) => ({ items: r.alerts, total: r.total })),
    [onlyTriggered]
  );
  const events = useAdminList((params) => admin.fetchAlertEvents(params).then((r) => ({ items: r.events, total: r.total })));
  const [actionError, setActionError] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);
  const [deleteTarget, setDeleteTarget] = useState<AdminAlert | null>(null);

  const runAction = async (id: string, action: () => Promise<unknown>) => {
    setBusyId(id);
    setActionError(null);
    try {
      await action();
      await alerts.reload();
    } catch (err) {
      setActionError(err instanceof Error ? err.message : 'No se pudo completar la acción.');
    } finally {
      setBusyId(null);
    }
  };

  const handleDelete = () => {
    if (!deleteTarget) return;
    runAction(deleteTarget.id, () => admin.deleteAlert(deleteTarget.id));
  };

  const current = tab === 'configured' ? alerts : events;

  return {
    tab,
    setTab,
    alerts,
    events,
    onlyTriggered,
    setOnlyTriggered,
    loading: current.loading,
    error: actionError ?? current.error,
    busyId,
    deleteTarget,
    setDeleteTarget,
    runAction,
    handleDelete,
    toggleEnabled: (a: AdminAlert) => runAction(a.id, () => admin.updateAlert(a.id, { enabled: !a.enabled })),
    restoreAlert: (id: string) => runAction(id, () => admin.restoreAlert(id)),
  };
}
